import { Drawer, Dropdown, List, Spin, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { AiFillPlusCircle, AiOutlineQuestionCircle } from "react-icons/ai";
import { BiRefresh } from "react-icons/bi";
import { IoClose } from "react-icons/io5";
import { SlOptionsVertical } from "react-icons/sl";
import { useDispatch, useSelector } from "react-redux";
import { CusAssetsMiddleware } from "../../../Store/Middlewares/CusAssetsMiddleware";
import filterImg from "../../../assets/images/filter.png";
import imagePlaceholder from "../../../assets/images/imageplace.jpg";
import {
  Modal,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../components";
import Card from "../../../components/Card/Card";
import Switch from "../../../components/Switch/Switch";
import BatteryStatus from "../../../components/battery/Battery";
import FloatingButton from "../../../components/floatingButton/FloatBtn";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { extractBytes, hexToBase64 } from "../../../utills";
import { pusher } from "../../../utills/PusherHandler";
import AddAssets from "../../Dealership/AssetsManagement/AddAssets/AddAssets";
import EditAssets from "../../Dealership/AssetsManagement/EditAsset/EditAsset";
import EditScheduleModal from "../../Dealership/AssetsManagement/ScheduleModal/EditScheduleModal";
import ScheduleModal from "../../Dealership/AssetsManagement/ScheduleModal/ScheduleModal";
import styles from "./assets.module.css";
import { CusModulesMiddleware } from "../../../Store/Middlewares/CusModulesMiddleware";
import dummyImg from "../../../assets/images/dummy.png";
import assetsAssignImg from "../../../assets/images/car.png";
import { FaCirclePlus } from "react-icons/fa6";
import { PiSealCheck } from "react-icons/pi";
import SharedAccess from "../Module/SharedAccess/SharedAccess";

const scheduleData = [
  {
    id: 1,
    title: "Immobilizer Activation",
    ferquency: "Daily",
    type: "single",
    isImobilized: true,
    isModuleConected: true,
    time: "10:00 AM",
    assets: [
      {
        name: "Honda Accord",
        vin: "4T1B11HK6MU123456",
        year: "2018",
        img: require("../../../assets/images/staticImages/c1.png"),
        isImobilized: true,
      },
    ],
  },
  {
    title: "High Security mode",
    ferquency: "Daily",
    type: "group",
    groupName: "Family Car",
    isImobilized: false,
    time: "10:00 PM",
    isModuleConected: true,
    assets: [
      {
        name: "Hyundai Tucson",
        vin: "4T1B11HK6MU123456",
        year: "2018",
        img: require("../../../assets/images/staticImages/c3.png"),
      },
      {
        name: "Audi A4",
        vin: "4T1B11HK6MU123456",
        year: "2022",
        img: require("../../../assets/images/staticImages/c2.png"),
      },
    ],
  },
  {
    title: "Immobilizer Health Check",
    ferquency: "Monday",
    isImobilized: true,
    isModuleConected: false,
    type: "single",
    time: "10:00 AM",
    assets: [
      {
        name: "Honda Accord",
        vin: "4T1B11HK6MU123456",
        year: "2018",
        img: require("../../../assets/images/staticImages/c1.png"),
        isImobilized: true,
      },
    ],
  },
];

const Assets = () => {
  const dispatch = useDispatch();
  const ref = useRef();
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState([]);
  const [openEditAssetsModal, setOpenEditAssetsModal] = useState(false);
  const [afterDispatch, setAfterDispatch] = useState(true);

  const [locationTracking, setLocationTracking] = useState(false);
  const [connectModal, setConnectModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModule, setDeleteModule] = useState(false);
  const [success, setSuccess] = useState(false);
  const [moduleSuccess, setModuleSuccess] = useState(false);
  const [openAddGroupAsset, setOpenAddGroupAsset] = useState(false);
  const [openEditGroupAsset, setOpenEditGroupAsset] = useState(false);
  const [openAddNewGroupAsset, setOpenAddNewGroupAsset] = useState(false);
  const [openAddAssetsModal, setOpenAddAssetsModal] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [editScheduleModal, setEditScheduleModal] = useState(false);
  const [selected, setselected] = useState(scheduleData?.[0]);
  const [schedule, setScheduleData] = useState(null);
  const [assetsSuccessModal, setAssetsSuccessModal] = useState(false);
  const [accessSharingModal, setAccessSharingModal] = useState(false);
  const [assignAssetsModal, setAssignAssetsModal] = useState(false);
  const [activeButton, setActiveButton] = useState("percentage");

  const { width } = useWindowDimensions();
  const ASSETS = useSelector((state) => state.CusAssetsReducer.getCusAssets);
  const user = useSelector((state) => state.AuthReducer.user);
  const ASSETDETAIL = useSelector(
    (state) => state.CusAssetsReducer.assetsDetail,
  );
  const MODULESTATUS = useSelector(
    (state) => state.CusAssetsReducer.setCusAssetsStatus,
  );
  const MODULE_DETAILS = useSelector(
    (state) => state?.CusModulesReducer?.modulesDetail,
  );
  const getCusUnlinkAssets = useSelector(
    (state) => state.CusAssetsReducer.getCusUnlinkAssets,
  );

  const [checkBattery, setcheckBattery] = useState(false);
  const chatchannel = useRef();
  useEffect(() => {
    initiatePusher();
    return () => {
      if (chatchannel?.current) {
        chatchannel?.current?.unsubscribe();
      }
    };
  }, []);

  const initiatePusher = () => {
    chatchannel.current = pusher.subscribe("phoenix-immobilizer");
    chatchannel.current.bind("App\\Events\\TTNUpLink", (data) => {
      if (data?.data?.device_id == ASSETDETAIL?.device_id) {
        if (data?.data?.ascii_payload?.includes("BV")) {
          const match = data?.data?.ascii_payload.match(/BV:([0-9.]+)/);
          const bvValue = match ? match[1] : null;
          dispatch(
            CusAssetsMiddleware.updateBatteryVolt({
              battery_volt: bvValue,
              asset_id: ASSETDETAIL?.id,
            }),
          ).then(() => setcheckBattery(false));
        }
      }
    });
  };

  const getBatteryVolt = () => {
    setcheckBattery(true);
    dispatch(
      CusAssetsMiddleware.sentDownlinkBattery({
        device_id: ASSETDETAIL?.device_id,
        action: hexToBase64(extractBytes(ASSETDETAIL.dev_eui) + "A5"),
      }),
    ).then(() => {
      setcheckBattery(false);
    });
  };

  useEffect(() => {
    dispatch(CusAssetsMiddleware.getCusAssets({ name: "" }));
    dispatch(CusAssetsMiddleware.getCusUnlinkAssets()).then((data) => {});
  }, []);

  useEffect(() => {
    if (!afterDispatch) setOpen(false);
  }, [!afterDispatch]);
  const onSearch = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      dispatch(CusAssetsMiddleware.getCusAssets({ name: value })).then(
        (data) => {},
      );
    }, 1000);
  };

  const onGetDetail = (id, module_id) => {
    dispatch(CusAssetsMiddleware.getCusAssetsDetail({ id })).then((data) => {
      setOpen(true);
      setDetails(data?.data?.data);
    });
    if (module_id && module_id != null) {
      dispatch(CusModulesMiddleware.getModuleDetails({ id: module_id })).then(
        (data) => {},
      );
    }
  };

  const onClickImmobilized = () => {
    dispatch(
      CusAssetsMiddleware.sentDownlink({
        device_id: ASSETDETAIL?.device_id,
        action:
          ASSETDETAIL?.status != "immobilized"
            ? hexToBase64(extractBytes(ASSETDETAIL.dev_eui) + "A1")
            : hexToBase64(extractBytes(ASSETDETAIL.dev_eui) + "A2"),
        status: ASSETDETAIL?.status == "immobilized" ? "drive" : "immobilized",
        asset_id: ASSETDETAIL?.id,
      }),
    ).then((res) => {
      onGetDetail(ASSETDETAIL?.id);
      // setOpen(false);
      // setDetails([]);
    });
  };

  const items2 = [
    {
      key: "3",
      label: <a onClick={() => setOpenEditAssetsModal(true)}>Edit details</a>,
    },
    {
      key: "4",
      label: (
        <a
          onClick={() => {
            setOpen(false);
            setDeleteModal(true);
          }}
        >
          Delete vehicle
        </a>
      ),
    },
  ];

  const items1 = [
    {
      key: "1",
      label: (
        <a
          onClick={() =>
            dispatch(CusAssetsMiddleware.unlinkAsset({ id: ASSETDETAIL.id }))
          }
        >
          Delete
        </a>
      ),
    },
  ];

  const renderItemScedule = (item) => {
    // console.log(item);

    const items3 = [
      {
        key: "3",
        label: (
          <a
            onClick={() => {
              setEditScheduleModal(true);
              setScheduleData(item);
            }}
          >
            Edit Schedule
          </a>
        ),
      },
      {
        key: "4",
        label: (
          <a
            onClick={() =>
              dispatch(
                CusAssetsMiddleware.DeleteAssetSchedule({ id: item?.id }),
              )
            }
          >
            Delete
          </a>
        ),
      },
    ];
    return (
      <div className={`${styles.scheduleCont}`}>
        <div>
          <TextComponent text={item?.name} className={styles.heading} />
          <div className={styles.scheduleLeftCont}>
            {/* <TextComponent
              text={
                item?.frequency == "one_time" ? "One time" : "Until turn off"
              }
              className={styles.text}
            /> */}
            <TextComponent
              text={`${item?.start_time}-${item?.end_time}`}
              className={styles.scheduleTime}
            />
            {/* <TextComponent text= className={styles.scheduleTime} /> */}
            {/* <Switch
              isChecked={item.status == "active" ? true : false}
              size="small"
              // style={
              //   item.isImobilized
              //     ? { backgroundColor: "var(--primary-color)" }
              //     : { backgroundColor: "var(--green-color)" }
              // }
              onChange={() => {
                // console.log("item id", item?.id);
                dispatch(
                  CusAssetsMiddleware.updateStatusSchedule({ id: item?.id }),
                );
              }}
              // disabled
            /> */}
          </div>
        </div>
        <div className={styles.mobStatusCont}>
          <Dropdown
            trigger={"click"}
            menu={{
              items: items3,
            }}
            placement="bottomRight"
            arrow={{
              pointAtCenter: true,
            }}
          >
            <button className={styles.menubtn}>
              <SlOptionsVertical
                size={20}
                color="var(--light-text)"
                cursor={"pointer"}
              />
            </button>
          </Dropdown>
        </div>
      </div>
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (text, data, index) => (
        <div>
          <TextComponent text={index + 1} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "Make",
      dataIndex: "image",
      key: "image",
      render: (item, data) => (
        <div className={styles.module}>
          <img
            src={data?.image ? data?.image : imagePlaceholder}
            className={styles.moduleImg}
          />
          <TextComponent text={data?.make} className={styles.moduletext} />
        </div>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (data) => (
        <div className={styles.module}>
          <TextComponent text={data} className={styles.moduletext} />
        </div>
      ),
    },
    {
      title: "Model",
      dataIndex: "model",
      key: "model",
      render: (text) => (
        <div>
          <TextComponent text={text} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "License Plate",
      dataIndex: "license_no",
      key: "license_no",
      render: (text) => (
        <div className={styles.carDiv}>
          <TextComponent text={text} className={styles.text} />
        </div>
      ),
    },
    {
      title: "VIN",
      dataIndex: "vin_no",
      key: "vin_no",
      render: (text) => {
        const lastEight = text ? text.toString().slice(-8) : "";

        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={lastEight} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Trim",
      dataIndex: "trim",
      key: "trim",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Stock",
      dataIndex: "stock_no",
      key: "stock_no",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text} className={styles.text} />
          </div>
        );
      },
    },
    {
      title: "Year",
      dataIndex: "year",
      key: "year",
      render: (text) => {
        return (
          <div className={styles.dealerDiv}>
            <TextComponent text={text} className={styles.text} />
          </div>
        );
      },
    },
  ];
  return (
    <div className={styles.upperCont}>
      <div className={styles.mainCont}>
        <div className={styles.header}>
          <TextComponent text={"Vehicles"} className={styles.headerHeading} />
          <div className={styles.rightHeader}>
            <div className={styles.searchInput}>
              <SearchInput
                onChange={(e) => onSearch(e)}
                // rightIcon={
                //   <img src={filterImg} className={styles.filterIcon} />
                // }
              />
            </div>
          </div>
        </div>
        <div className={styles.tableHeader}>
          <FloatingButton
            Buttons={[
              {
                title: "Add vehicle",
                onClick: () => setOpenAddAssetsModal(true),
              },
            ]}
            floatStyle={styles.floatingBtn}
            buttonStyles={styles.floatingButtonsContainer}
          />
        </div>
        <div className={styles.tableDiv}>
          <Table
            scroll={{ x: true }}
            bordered={false}
            pagination={false}
            columns={columns}
            dataSource={ASSETS?.single_assets}
            onRow={(record, rowIndex) => {
              return {
                onClick: () => onGetDetail(record?.id, record?.module_id),
                style: { cursor: "pointer" },
              };
            }}
          />
        </div>
      </div>
      {/* <FloatingButton
        Buttons={[
          { title: "Add vehicle", onClick: () => setOpenAddAssetsModal(true) },
        ]}
      /> */}
      <Drawer
        width={width < 550 ? "100%" : 600}
        headerStyle={{ display: "none" }}
        onClose={() => {
          setOpen(false);
          setDetails([]);
        }}
        open={open}
      >
        <div
          className={styles.crossIconDiv}
          onClick={() => {
            setOpen(false);
            setDetails([]);
          }}
        >
          <IoClose />
        </div>
        <div className={styles.rightCol}>
          <Card>
            <img
              src={ASSETDETAIL?.image || imagePlaceholder}
              alt=""
              className={styles.slectedImg}
            />
            <div className={styles.leftHeader}>
              <div>
                {details?.name && (
                  <TextComponent
                    text={`${details?.name ? details?.name : "-"}`}
                    className={styles.heading}
                  />
                )}
                {details?.make && (
                  <TextComponent
                    text={`${details?.make ? details?.make : "-"} `}
                    className={styles.heading}
                  />
                )}
                {details?.license_no && (
                  <TextComponent
                    text={`License Plate: ${details?.license_no}`}
                    className={styles.carDescText}
                  />
                )}
                {details?.vin_no && (
                  <TextComponent
                    text={`VIN: ${details?.vin_no}`}
                    className={styles.carDescText}
                  />
                )}
                {details?.model && (
                  <TextComponent
                    text={`Model: ${details?.model}`}
                    className={styles.carDescText}
                  />
                )}
                {/* <TextComponent text={"2016"] className={styles.carDescText} /> */}
                {/* <TextComponent
                  text={"Location: Lot A, Row 5"}
                  className={styles.carDescText}
                /> */}
              </div>
              <div>
                {details?.color && (
                  <TextComponent
                    text={`Color: ${details?.color}`}
                    className={styles.carDescText}
                  />
                )}
                {details?.trim && (
                  <TextComponent
                    text={`Trim: ${details?.trim}`}
                    className={styles.carDescText}
                  />
                )}
                {details?.stock_no && (
                  <TextComponent
                    text={`Stock No: ${details?.stock_no}`}
                    className={styles.carDescText}
                  />
                )}
                {details?.year && (
                  <TextComponent
                    text={`Year: ${details?.year}`}
                    className={styles.carDescText}
                  />
                )}
              </div>
              {ASSETDETAIL?.owner_id == user?.id && (
                <div>
                  <Dropdown
                    trigger={"click"}
                    menu={{
                      items: items2,
                    }}
                    placement="bottomRight"
                    arrow={{
                      pointAtCenter: true,
                    }}
                  >
                    <button className={styles.menubtn}>
                      <SlOptionsVertical
                        size={20}
                        color="var(--light-text)"
                        cursor={"pointer"}
                      />
                    </button>
                  </Dropdown>
                </div>
              )}
            </div>
          </Card>
          {ASSETDETAIL?.device_id && (
            <Card className={styles.card}>
              <div className={styles.leftHeader}>
                <div>
                  <TextComponent
                    text={ASSETDETAIL?.device_name}
                    className={styles.heading}
                  />

                  <TextComponent
                    text={ASSETDETAIL?.device_id}
                    className={styles.carDescText}
                  />
                  <TextComponent
                    text={"Connected via LoRaWAN"}
                    className={styles.carDescText}
                  />
                  <div className={styles.showbatterydiv}>
                    <TextComponent
                      text={"Show Battery in"}
                      className={styles.carDescText}
                    />
                    <div className={styles.buttonsbattery}>
                      <button
                        style={{
                          background:
                            activeButton == "percentage"
                              ? "var(--green-color)"
                              : "var(--light-grey)",
                        }}
                        onClick={() => setActiveButton("percentage")}
                      >
                        Percentage
                      </button>
                      <button
                        style={{
                          background:
                            activeButton == "volt"
                              ? "var(--green-color)"
                              : "var(--light-grey)",
                        }}
                        onClick={() => setActiveButton("volt")}
                      >
                        Volt
                      </button>
                    </div>
                  </div>

                  <div className="flex-start">
                    {activeButton == "percentage" ? (
                      <BatteryStatus
                        percentage={parseFloat(
                          details?.battery_volt
                            ? (details?.battery_volt / 12) * 100
                            : (12 / 12) * 100,
                        ).toFixed(0)}
                      />
                    ) : (
                      <TextComponent
                        text={`Battery
                        ${
                          details?.battery_volt
                            ? details?.battery_volt + "V"
                            : "12V"
                        }`}
                      />
                    )}
                    <div style={{ marginLeft: "10px" }}>
                      {checkBattery ? (
                        <Spin
                          size="small"
                          style={{ color: "var(--secondary-color)" }}
                        />
                      ) : (
                        <BiRefresh
                          size={20}
                          style={{ cursor: "pointer" }}
                          onClick={getBatteryVolt}
                        />
                      )}
                    </div>
                  </div>
                  {/* <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {activeButton == "percentage" ? (
                      <BatteryStatus
                        percentage={parseFloat(
                          ASSETDETAIL?.battery_volt
                            ? (ASSETDETAIL?.battery_volt / 12) * 100
                            : (12 / 12) * 100,
                        ).toFixed(0)}
                      />
                    ) : (
                      <TextComponent
                        text={`Battery
                        ${
                          ASSETDETAIL?.battery_volt
                            ? ASSETDETAIL?.battery_volt + "V"
                            : "12V"
                        }`}
                      />
                    )}
                    <div style={{ marginLeft: "10px" }}>
                      {checkBattery ? (
                        <Spin
                          size="small"
                          style={{ color: "var(--secondary-color)" }}
                        />
                      ) : (
                        <BiRefresh
                          size={20}
                          style={{ cursor: "pointer" }}
                          onClick={getBatteryVolt}
                        />
                      )}
                    </div>
                  </div> */}
                  <div className={styles.scheduleLeftCont}>
                    <Switch
                      isChecked={
                        MODULESTATUS?.status == "immobilized" ? true : false
                      }
                      size="small"
                      onChange={onClickImmobilized}
                    />
                    <TextComponent
                      text={
                        MODULESTATUS?.status == "immobilized"
                          ? "Immobilized"
                          : "Drive"
                      }
                      className={styles.text}
                    />
                  </div>
                </div>
                {ASSETDETAIL?.owner_id == user?.id && (
                  <div>
                    <Dropdown
                      trigger={"click"}
                      menu={{
                        items: items1,
                      }}
                      placement="bottomRight"
                      arrow={{
                        pointAtCenter: true,
                      }}
                    >
                      <button className={styles.menubtn}>
                        <SlOptionsVertical
                          size={20}
                          color="var(--light-text)"
                          cursor={"pointer"}
                        />
                      </button>
                    </Dropdown>
                  </div>
                )}
              </div>
            </Card>
          )}
          {MODULE_DETAILS?.asset_id && (
            <div className={styles.subContChild}>
              <TextComponent
                style={{
                  fontFamily: "Urbanist-bold",
                  fontSize: "var(--paragraph-font-size)",
                }}
                text={"Access details"}
              />
              <div className={styles.Access_Owner}>
                <TextComponent
                  style={{ color: "var( --light-text)" }}
                  text={`Owner: ${
                    MODULE_DETAILS?.owner_id == user?.id
                      ? "You"
                      : MODULE_DETAILS?.owner_name
                  }`}
                />
                {(MODULE_DETAILS?.owner_id == user?.id ||
                  ASSETDETAIL?.sold_to == user?.id) && (
                  <div>
                    <TextComponent
                      onClick={() => {
                        setAccessSharingModal(true);
                      }}
                      className={styles.access_sharedBtn}
                      text={"Share Access"}
                    />
                  </div>
                )}
              </div>
              {/* {MODULE_DETAILS?.owner_id == user?.id && (
                <TextComponent
                  style={{
                    fontFamily: "Urbanist-semibold",
                    fontSize: "var(--mobile-sub-heading)",
                  }}
                  text={"Shared access"}
                />
              )} */}

              {MODULE_DETAILS?.owner_id == user?.id &&
                MODULE_DETAILS?.shared_access?.length > 0 && (
                  <List
                    className={styles.access_list}
                    dataSource={MODULE_DETAILS?.shared_access}
                    renderItem={(item, index) => (
                      <div key={index} className={styles.access_listItem}>
                        <div className={styles.access_listLeft}>
                          <img src={item?.image ? item?.image : dummyImg} />
                          <TextComponent
                            style={{
                              fontSize: "var(--mobile-sub-heading)",
                              fontFamily: "Urbanist-semibold",
                            }}
                            text={item.email}
                          />
                        </div>
                        <div
                          className={styles.access_remove}
                          onClick={() => {
                            dispatch(
                              CusModulesMiddleware.removeAccess({
                                asset_id: MODULE_DETAILS?.asset_id,
                                user_id: item?.id,
                              }),
                            );
                          }}
                        >
                          <TextComponent text={"Remove"} />
                        </div>
                      </div>
                    )}
                  />
                )}
            </div>
          )}
          {ASSETDETAIL?.device_id
            ? (ASSETDETAIL?.owner_id == user?.id ||
                (ASSETDETAIL?.sold_to !== null &&
                  ASSETDETAIL?.sold_to == user?.id)) && (
                <Card className={styles.card}>
                  <div className={styles.header}>
                    <TextComponent
                      text={"Schedule"}
                      className={styles.heading}
                    />
                    <div
                      className={styles.btnScedule}
                      onClick={() => setScheduleModal(true)}
                    >
                      <TextComponent text={"Add"} />
                      <AiFillPlusCircle
                        size={18}
                        style={{ marginLeft: "5px" }}
                        color="var(--primary-color)"
                      />
                    </div>
                  </div>
                  {/* {ASSETDETAIL?.schedules.length != 0 && ( */}
                  <List
                    dataSource={ASSETDETAIL?.schedules}
                    renderItem={renderItemScedule}
                  />
                  {/* )} */}
                </Card>
              )
            : null}
        </div>
      </Drawer>
      <AddAssets
        from={"customer"}
        isOpen={openAddAssetsModal}
        setIsOpen={setOpenAddAssetsModal}
      />
      <EditAssets
        from={"customer"}
        isOpen={openEditAssetsModal}
        setIsOpen={setOpenEditAssetsModal}
        details={details}
        afterDispatch={setAfterDispatch}
      />
      <ScheduleModal
        from={"customer"}
        scheduleModal={scheduleModal}
        setScheduleModal={setScheduleModal}
        details={details}
        afterDispatch={setAfterDispatch}
      />
      <EditScheduleModal
        from={"customer"}
        scheduleModal={editScheduleModal}
        setScheduleModal={setEditScheduleModal}
        afterDispatch={setAfterDispatch}
        details={details}
        scheduleData={schedule}
      />
      <SharedAccess
        accessSharingModal={accessSharingModal}
        setAccessSharingModal={setAccessSharingModal}
      />
      <Modal
        open={deleteModal}
        onCancel={() => {
          setDeleteModal(false);
        }}
        icon={
          <AiOutlineQuestionCircle
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        twoButton
        okBtnTitle={"Yes, delete"}
        cancelBtnTitle={"No, go back"}
        title={"Are you sure"}
        text={"You want to delete this Vehicle?"}
        width={400}
        onClickCancelButton={() => {
          setDeleteModal(false);
        }}
        onClickOkButton={() => {
          dispatch(
            CusAssetsMiddleware.DeleteAsset({ id: ASSETDETAIL?.id }),
          ).then(() => {
            setDeleteModal(false);
            setSuccess(true);
          });
        }}
        headingClass={styles.modalHeading}
      ></Modal>
      {/* /////////////////////////Asset Assigned Modal///////////////////////// */}
      <Modal
        open={assignAssetsModal}
        onCancel={() => setAssignAssetsModal(false)}
        imageClass={styles.assignAssetsImgStyle}
        icon={
          <img
            src={assetsAssignImg}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        width={"600px"}
        twoButton
        okBtnTitle={"Add new vehicle"}
        cancelBtnTitle={"Go Back"}
        leftBtnIcon={
          <FaCirclePlus
            size={15}
            color="var(--white-color)"
            style={{ marginRight: "5px" }}
          />
        }
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setAssignAssetsModal(false);
        }}
        onClickOkButton={() => {
          setAssignAssetsModal(false);
          // setOpenAddAssetsModal(true);
        }}
        headingClass={styles.modalHeading}
      >
        <>
          <TextComponent
            text={"Assign Vehicle"}
            style={{
              fontFamily: "Urbanist-bold",
              fontSize: "var(--heading2-font-size)",
            }}
          />
          <div className={styles.assetsCont}>
            <List
              dataSource={getCusUnlinkAssets}
              renderItem={(item, index) => (
                <div className={styles.assetsItemDiv} key={index}>
                  {" "}
                  <div className={styles.assetslistItem} key={index}>
                    <div className={styles.assetsImgDiv}>
                      <img src={item?.image ? item?.image : imagePlaceholder} />
                      <div className={styles.assetslistText}>
                        {/* <div className={styles.assetslistTextTop}> */}
                        <TextComponent
                          text={`Model: ${item?.model ? item?.model : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        <TextComponent
                          text={`Make: ${item?.make ? item?.make : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        {/* </div> */}
                        {/* <div className={styles.assetslistTextTop}> */}
                        <TextComponent
                          text={`VIN: ${item?.vin_no ? item?.vin_no?.toString().slice(-8) : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        <TextComponent
                          text={`Stock No: ${item?.stock_no ? item?.stock_no : "--"}`}
                          style={{
                            fontFamily: "Urbanist-bold",
                            fontSize: "var(--mobile-heading)",
                          }}
                        />
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                  <SubmitButton
                    secondaryBtn
                    title={"Assign"}
                    style={{ marginTop: "10px" }}
                    onClick={() => {
                      dispatch(
                        CusAssetsMiddleware.cusAssignAsset({
                          assetId: item?.id,
                          deviceId: MODULE_DETAILS?.device_id,
                        }),
                      ).then(() => {
                        setAssetsSuccessModal(true);
                        setAssignAssetsModal(false);
                        // setOpen(false);
                        setDetails([]);
                      });
                    }}
                  />
                </div>
              )}
            />
          </div>
        </>
      </Modal>
      {/* /////////////////////////Asset Assigned Successfull///////////////////////// */}
      <Modal
        open={assetsSuccessModal}
        onCancel={() => setAssetsSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Asset Assigned successfully"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setAssetsSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      >
        {" "}
      </Modal>
    </div>
  );
};

{
  /* <EditAssets
        isOpen={openEditAssetsModal}
        setIsOpen={setOpenEditAssetsModal}
      /> */
}
{
  /* <TrackingModal
        locationTracking={locationTracking}
        setLocationTracking={setLocationTracking}
        assets={[1, 2, 3, 4]}
      /> */
}
{
  /* <AddAssets
        isOpen={openAddAssetsModal}
        setIsOpen={setOpenAddAssetsModal}
      />
      <AddGroupAssetModal
        isOpen={openAddGroupAsset}
        setIsOpen={setOpenAddGroupAsset}
      />

      <EditGroupAssetModal
        isOpen={openEditGroupAsset}
        setIsOpen={setOpenEditGroupAsset}
      />
      <AddNewGroupAssetModal
        isOpen={openAddNewGroupAsset}
        setIsOpen={setOpenAddNewGroupAsset}
      />
    
     */
}
{
  /* <ConnectModule
        connectModal={connectModal}
        setConnectModal={setConnectModal}
      /> */
}
{
  /* 

      <Modal
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Group Deleted successfully"}
        width={"300px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>

      <Modal
        open={deleteModule}
        onCancel={() => {
          setDeleteModule(false);
        }}
        icon={
          <AiOutlineQuestionCircle
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        twoButton
        okBtnTitle={"Yes, Remove"}
        cancelBtnTitle={"No, go back"}
        title={"Are you sure"}
        text={"You want to remove this Module?"}
        width={400}
        // btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setDeleteModule(false);
        }}
        onClickOkButton={() => {
          setModuleSuccess(true);
          setDeleteModule(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
      <Modal
        open={moduleSuccess}
        onCancel={() => setModuleSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Module Removed Successfully"}
        width={"300px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setModuleSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal> */
}
{
  /* </div> */
}

export default Assets;
